import { Button, Divider, FormControl, FormLabel, Input, Text} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import Modal from "../Modal";
import { CreatableSelect } from "chakra-react-select";
import { useState, useEffect } from "react";
import getRolesArray from "../../utils/rolesTypes";
import { getAxiosInstance } from "../../utils/axiosInstance";
import { toast } from "react-toastify";
import { getRandomColor } from "../../utils/getRandomColor";

interface NewUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  resetPassword : (userId: string) => void;
  data: any;
}

const EditModalUser = (props: NewUserModalProps) => {
  const { t } = useTranslation("translations");
  const [user, setUser] = useState<any>({});
  const [roles, setRoles] = useState<any[]>([]);
  const [roleType, setRoleType] = useState<any[]>([]);
  const [selectedPlacesOfBusiness, setSelectedPalacesOfBusiness] = useState<string[]>([]);
  const [placesOfBusiness, setPlacesOfBusiness] = useState<{ value: string; label: string; colorScheme: string }[]>([]);

  const deleteEntity = (
    <Button
      onClick={(e) => {
        deleteUser();
      }}
      className="mr-2"
      name={"Delete"}
      colorScheme={"red"}
      variant={"outline"}
    >
      {t("DELETE")}
    </Button>
  );

  const setUpUserObject = (value: string, name: string) => {
    setUser({ ...user, [name]: value });
  };

  const getPlacesOfBusiness = async () => {
    try {
      const res = await getAxiosInstance().get("/Companies/places-of-business");
      const tmp = [];
      for (const t of res.data) {
        tmp.push({
          value: t.id,
          label: `${t.name} (${t.companyName})`,
          colorScheme: getRandomColor(),
        });
      }
      setPlacesOfBusiness(tmp);
    } catch (e) {
      toast.error(t(`PLACE_OF_BUSINESS_FETCH_ERROR`), {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  useEffect(() => {
    setUser(props.data);
  }, [props.data]);

  const update = async () => {
    try {
      await getAxiosInstance().put("/users", {
        id: user.id,
        userName: user.userName,
        email: user.email,
        displayName: user.displayName,
        roles: roles.map((r) => ({ name: r })),
        palcesOfBusiness: selectedPlacesOfBusiness,
      });

      toast.success(t("USER_UPDATED_SUCCESSFULLY"), {
        position: toast.POSITION.BOTTOM_RIGHT,
      });

      props.onClose();

    } catch (error) {
      toast.error(t("SOMETHING_WENT_WRONG"), {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  const deleteUser = async () => {
    try {
      await getAxiosInstance().delete(`/users/${user.id}`);
      toast.success(t("USER_DELETED_SUCCESSFULLY"), {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      props.onClose();
    } catch (error) {
      toast.error(t("SOMETHING_WENT_WRONG"), {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  

  useEffect(() => {
    (async () => {
      const rolest = await getRolesArray();
      if (props.data.original_roles) {
        setRoles(props.data.original_roles);
      }
      setRoleType(rolest);
    })();
    setSelectedPalacesOfBusiness(
      props.data.placesOfBusiness
        ? props.data.placesOfBusiness.map((x: any) => x.id)
        : []
    );
  }, [props.data]);

  useEffect(() => {
    getPlacesOfBusiness();
  }, []);

  return (
    <>
      <Modal
        header={t("Edit User")}
        isOpen={props.isOpen}
        onClose={props.onClose}
        secondaryActionName={t("Save")}
        secondaryActionEnabled={true}
        secondaryAction={() => {
          update();
        }}
        additionalBtn={deleteEntity}
      >
        <FormControl>
          <FormLabel>{t("Username")}</FormLabel>
          <Input
            isRequired
            name="userName"
            value={user.userName}
            onChange={(e) => setUpUserObject(e.target.value, e.target.name)}
          />
        </FormControl>
        <FormControl>
          <FormLabel> {t("Email")} </FormLabel>
          <Input
            isRequired
            name="email"
            type="email"
            value={user.email}
            onChange={(e) => setUpUserObject(e.target.value, e.target.name)}
          />
        </FormControl>
        <FormControl>
          <FormLabel> {t("Display Name")} </FormLabel>
          <Input
            isRequired
            name="displayName"
            value={user.displayName}
            onChange={(e) => setUpUserObject(e.target.value, e.target.name)}
          />
        </FormControl>
        <FormControl>
          <FormLabel> {t("Roles")} </FormLabel>
          <CreatableSelect
            isRequired
            name="types"
            options={roleType}
            placeholder="Select user roles..."
            value={roles.map((x) => {
              const index = roleType.findIndex((y) => y.value === x);
              if (index !== -1) {
                return roleType[index];
              }
            })}
            closeMenuOnSelect={false}
            onChange={(e) => setRoles([...e.map((x) => x.value)])}
            isMulti
          />
        </FormControl>
        <FormControl>
          <FormLabel> {t("PlacesOfBusiness")} </FormLabel>
          <CreatableSelect
            name={t("PlacesOfBusiness")}
            options={placesOfBusiness}
            value={placesOfBusiness.filter(
              (x) =>
                selectedPlacesOfBusiness.findIndex((y) => y === x.value) !== -1
            )}
            placeholder={t("SELECT_USER_PLACE_OF_BUSINESS")}
            onChange={(e) =>
              setSelectedPalacesOfBusiness(e.map((x) => x.value))
            }
            isMulti
          />
        </FormControl>

        <Text className="my-2"  fontSize={"xl"}>
            {t("USER_EXTRA_ACTIONS")}
        </Text>
        <Divider className="m-2" />
        <Button
          className="w-full"
          colorScheme='yellow'
          onClick={() => { props.resetPassword(user.id) }}
        >
          {t("RESET_USER_PASSWORD")}
        </Button>
   
       
      </Modal>
    </>
  );
};

export default EditModalUser;
